import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal, useModal } from "../../modal";
import { Button } from "@mui/material";
import { GridContainer } from "./MonthlyReport.styles";
import { ResetStore } from "./MonthlyReport.slice";
import MonthlyReportHeader from "./MonthlyReport.header";
import MonthlyReportAcquirer from "./MonthlyReport.acquirer";
import MonthlyReportISO from "./MonthlyReport.iso";
import MonthlyReportMerchant from "./MonthlyReport.merchant";
import MonthlyReportAdmin from "./MonthlyReport.admin";
import { downloadMonthlyReportCSV } from "./MonthlyReport.utils";

const MonthlyReportResultModal = () => {
  const dispatch = useDispatch();
  const { close } = useModal();
  const { isOpen } = useSelector((state) => state.modal);
  const { reportData } = useSelector((state) => state.monthlyReport);

  if (!isOpen || !reportData) {
    return null;
  }

  const handleClose = () => {
    close();
    dispatch(ResetStore());
  };

  const handleDownloadCSV = () => {
    downloadMonthlyReportCSV(reportData);
  };

  const { userType } = reportData;

  const renderReportContent = () => {
    switch (userType) {
      case "acquirer":
        return <MonthlyReportAcquirer reportData={reportData} />;
      case "iso":
        return <MonthlyReportISO reportData={reportData} />;
      case "merchant":
        return <MonthlyReportMerchant reportData={reportData} />;
      case "admin":
        return <MonthlyReportAdmin reportData={reportData} />;
      default:
        // Fallback to acquirer structure for backwards compatibility
        return <MonthlyReportAcquirer reportData={reportData} />;
    }
  };

  return (
    <Modal
      fullScreen
      actions={
        <>
          <Button onClick={handleDownloadCSV} variant="contained" color="primary">
            Download CSV
          </Button>
          <Button onClick={handleClose} variant="outlined">
            Close
          </Button>
        </>
      }
    >
      <GridContainer spacing={0}>
        <MonthlyReportHeader reportData={reportData} />
        {renderReportContent()}
      </GridContainer>
    </Modal>
  );
};

export default MonthlyReportResultModal;
